import {ENABLED_STATUS_MESSAGE_KEY_BY_STATUS, enabledStatus} from "./constants";
import {arrayToSet} from "../../atUtils";
import {WorkflowStatusType} from "../../workflowStatus/constants";
import {workflowStatusComparator} from "../../workflowStatus/utils";

export function getEnabledStatusMessageKeyByStatus(status) {
    return ENABLED_STATUS_MESSAGE_KEY_BY_STATUS[status]
}

export function prepareWorkflowStatusesForPage(statusesInUseIds = [], allStatusesMap = {}) {
    const usedStatusesIdsSet = arrayToSet(statusesInUseIds)
    const statuses = Object.values(allStatusesMap).sort(workflowStatusComparator)

    let openStatusesCount = 0
    let completedStatusesCount = 0
    let statusesForReturn = []
    statuses.forEach(status => {
        if (status.type === WorkflowStatusType.OPEN) {
            openStatusesCount++
        } else {
            completedStatusesCount++
        }

        statusesForReturn.push({
            ...status,
            enabledStatus: usedStatusesIdsSet[status.id] === true ? enabledStatus.IN_USE : enabledStatus.ENABLED
        })
    })

    const updateLastItemEnabledStatus = (statusType) => {
        const ind = statusesForReturn.findIndex(({type}) => type === statusType)
        statusesForReturn[ind] = {
            ...statusesForReturn[ind],
            enabledStatus: enabledStatus.LAST
        }
    }
    if (openStatusesCount === 1) {
        updateLastItemEnabledStatus(WorkflowStatusType.OPEN)
    }
    if (completedStatusesCount === 1) {
        updateLastItemEnabledStatus(WorkflowStatusType.COMPLETED)
    }
    return statusesForReturn
}



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/utils.js